// extracted by mini-css-extract-plugin
module.exports = {"details":"styles_details__1zztx","customContent":"styles_customContent__ZpRGx"};